import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import Logo from '../images/logo-cattolica-angel-only-16-9.png';
import { setHeadContent } from '../utils/functions';

const Seo = ({
  title,
  description,
  image,
  robots,
  link,
  type,
  scripts,
  lang,
  meta,
  keywords,
  jsonLd,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query DefaultSEOQuery {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const ogType = type || `website`;
  const ogImage = image || site.siteMetadata.siteUrl + Logo;
  const mRobots = robots || 'all';
  const mLink = link.endsWith('/') ? link : link + '/';

  const siteUrl = site.siteMetadata.siteUrl;

  const jsonLdData = (() => {
    let validJson = false;
    try {
      validJson = JSON.parse(jsonLd);
    } catch (e) {}
    return validJson;
  })();

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `robots`,
          content: mRobots,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: ogType,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:url`,
          content: site.siteMetadata.siteUrl + mLink,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
      link={getLinks(siteUrl, mLink)}
    >
      {setHeadContent(scripts)}

      {jsonLdData && (
        <script type='application/ld+json'>{JSON.stringify(jsonLdData)}</script>
      )}
    </Helmet>
  );
};

const getLinks = (siteUrl, mLink) => {
  const pageLinks = [
    {
      rel: 'canonical',
      href: siteUrl + mLink,
    },
  ];

  return pageLinks;
};

Seo.defaultProps = {
  lang: `it`,
  meta: [],
  keywords: [],
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default Seo;
